"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _AvatarField = _interopRequireDefault(require("./AvatarField"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(1),
    marginTop: -theme.spacing(0.5),
    marginBottom: -theme.spacing(0.5)
  }
}));

const FullNameField = _ref => {
  let {
    record,
    size
  } = _ref;
  const classes = useStyles();
  return record ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_AvatarField.default, {
    className: classes.avatar,
    size: size,
    record: record
  }), "".concat(record.firstName, " ").concat(record.lastName)) : null;
};

FullNameField.propTypes = {
  record: _propTypes.default.object,
  // source: PropTypes.string,
  // label: PropTypes.string,
  size: _propTypes.default.string
};
FullNameField.defaultProps = {// source: 'firstName',
  // label: 'resources.customers.fields.name',
};
var _default = FullNameField;
exports.default = _default;